var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":_vm.size,"height":_vm.size,"viewBox":"0 0 12 12","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","aria-hidden":"true"}},[_c('line',{attrs:{"x1":"6","y1":"2","x2":"6","y2":"10"}}),_c('line',{attrs:{"x1":"2","y1":"6","x2":"10","y2":"6"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }